import React from "react";
import "../components/componentstyle/productGrid.css";
import productImg1 from "../assets/product-img1.jpg";
import productImg2 from "../assets/product-img2.jpg";
import productImg3 from "../assets/product-img3.jpg";
import productImg4 from "../assets/product-img4.jpg";
import productImg5 from "../assets/product-img5.jpg";
import productImg6 from "../assets/product-img6.jpg";
import productImg7 from "../assets/product-img7.jpg";
import productImg8 from "../assets/product-img8.jpg";

const ProductGrid = () => {
  const products = [
    { name: "Black Eye Bean", img: productImg1 },
    { name: "Brown Eye Bean", img: productImg2 },
    { name: "Split Chickpea", img: productImg3 },
    { name: "Split Pigeon Pea", img: productImg4 },
    { name: "Kabuli Chickpea", img: productImg5 },
    { name: "Desi Chickpea", img: productImg6 },
    { name: "Kidney Bean", img: productImg7 },
    { name: "Red Kidney Bean", img: productImg8 },
  ];

  return (
    <section className="product-section py-5 text-center">
      <div className="container">
        <h2 className="product-heading mb-5">
          <span className="highlight">Our</span> Products
        </h2>
        <div className="row">
          {products.map((product, idx) => (
            <div key={idx} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 productMain">
              <div className="product-card  shadow">
                <img
                  src={product.img}
                  alt={product.name}
                  className="img-fluid"
                />
                <div className="product-label">
                  <div className="product-name">{product.name}</div>
                  {/* <div className="underline" /> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductGrid;
